/**
 * One queue per grid. Upload reservations must name the grid's current working revision and a draft
 * save moves that revision on, so the two never run at the same time for one grid.
 */
export class GridQueue {
  private readonly tails = new Map<string, Promise<unknown>>();

  run<T>(gridId: string, work: () => Promise<T>): Promise<T> {
    const previous = this.tails.get(gridId) ?? Promise.resolve();
    const next = previous.then(work, work);
    const tail = next.then(() => undefined, () => undefined);
    this.tails.set(gridId, tail);
    void tail.then(() => { if (this.tails.get(gridId) === tail) this.tails.delete(gridId); });
    return next;
  }

  clear(): void { this.tails.clear(); }
}
